export default function without(obj, ...props) {
  return Object.keys(obj).reduce((cleanedObj, prop) => {
    if (props.indexOf(prop) > -1) {
      return cleanedObj;
    }

    return {
      ...cleanedObj,
      [prop]: obj[prop],
    };
  }, {});
}



// WEBPACK FOOTER //
// ./src/utils/without.js